import Page from 'flarum/common/components/Page';
import PictureShow from '../components/PictureShow';

export default class PictureShowPage extends Page {
    bodyClass = 'cimaise-picture-show'

    view() {
        return m('.PictureShowPage', m(PictureShow, {
            id: m.route.param('id'),
        }));
    }
}
